var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"error-wrapper"},[_c('img',{attrs:{"width":"98px","src":require(("@/assets/" + _vm.type + ".svg"))}}),_c('div',{staticClass:"error-text"},[_vm._v(_vm._s(_vm.errorText))])])}
var staticRenderFns = []

export { render, staticRenderFns }